import { styled } from "@mui/material";
import { Button } from "components/ui";

export const StyledButton = styled(Button)`
  height: 48px;
`;
